<template>
  <el-container class="channel-detail">
    <el-container>
      <el-header>{{file.examplename || file.name}}</el-header>
      <el-main v-loading="loading">
        <section class="empty-tip" v-if="!loading && !(model.example && model.example.examplename)">
          <p>参考案例还在路上，如急需，请咨询</p>
          <p>商务负责人：{{model.responsor}}</p>
          <template v-if="responsor.name">
            <p>手机：{{responsor.mobile}}</p>
            <p>部门：{{responsor | bumen}}</p>
          </template>
          <p>欢迎随时来撩，竭诚为您服务！</p>
          <p>先选择右侧宣传材料了解一下渠道详细资料吧！</p>
        </section>
      </el-main>
    </el-container>
    <el-aside width="440px">
      <el-tabs type="card" class="right-tabs">
        <el-tab-pane label="设置">
          <el-form label-width="120" label-position="right">
            <el-form-item label="渠道名：">
              <span>{{model.name}}</span>
            </el-form-item>
            <el-form-item label="渠道栏目：">
              <span>{{model | convertChannel}}</span>
            </el-form-item>
            <el-form-item label="渠道简介：">
              <span>{{model.info}}</span>
            </el-form-item>
            <el-form-item label="流量规模：">
              <span>{{model.scale}}</span>
            </el-form-item>
            <el-form-item label="合作方式：">
              <template v-if="model.how">
                <el-tag type="info" v-for="item in model.how.split('/')" :key="item">{{item}}</el-tag>
              </template>
            </el-form-item>
            <el-form-item label="商务价格：">
              <span>{{model.price}}</span>
            </el-form-item>
            <el-form-item label="合作流量规模：">
              <span>{{model.scale2}}</span>
            </el-form-item>
            <el-form-item label="当前合作状态：">
              <span>{{model.status}}</span>
            </el-form-item>
            <el-form-item label="商务负责人：">
              <span class="user" @click="showUser(responsor, '商务负责人')">{{model.responsor}}</span>
            </el-form-item>
            <el-form-item label="运营负责人：">
              <span class="user" @click="showUser(responsor2, '运营负责人')">{{model.responsor2}}</span>
            </el-form-item>
            <el-form-item label="入口方式：">
              <span>{{model.position}}</span>
            </el-form-item>
            <el-form-item label="位置图片：">
              <span>
                <img
                  v-for="item in model.position_img_id"
                  :key="item.fileid"
                  @click="showImage($event)"
                  :src="`/api/changjing/get?i=${item.fileid}`"
                />
              </span>
            </el-form-item>
            <el-form-item label="参考案例：">
              <div v-if="model.example && model.example.examplename">
                <p @click="change(model.example)">{{model.example && model.example.examplename}}</p>
                <i @click="download(model.example)">下载</i>
              </div>
              <div v-else>无</div>
            </el-form-item>
            <el-form-item label="宣传材料：">
              <div v-for="item in model.file" :key="item.name">
                <p @click="change(item)">{{item.name}}</p>
                <i @click="download(item)">下载</i>
              </div>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="交流">
          <comment></comment>
        </el-tab-pane>
      </el-tabs>

    </el-aside>
    <el-dialog :visible.sync="visible" width="70%">
      <img :src="imgUrl" />
    </el-dialog>
    <el-dialog
      :title="user.title"
      custom-class="changjing-user-detail"
      :visible.sync="user.visible"
      width="600px"
    >
      <div>
        <img :src="user.model.photo" />
        <article>
          <p>
            <b>工号：</b>
            <span>{{user.model.id}}</span>
          </p>
          <p>
            <b>姓名：</b>
            <span>{{user.model.name}}</span>
          </p>
          <p>
            <b>手机：</b>
            <span>{{user.model.mobile}}</span>
          </p>
          <p>
            <b>邮箱：</b>
            <a :href="`mailto:${user.model.email}`">{{user.model.email}}</a>
          </p>
          <p>
            <b>部门：</b>
            <span>{{user.model | bumen}}</span>
          </p>
        </article>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import http from '@/plugins/axios'
import comment from './#comment'
export default {
  components: {
    comment
  },
  data() {
    return {
      imgUrl: '',
      loading: true,
      visible: false,
      model: {},
      file: {},
      user: {
        title: '',
        visible: false,
        model: {}
      },
      responsor: {},
      responsor2: {}
    }
  },
  beforeRouteEnter(to, from, next) {
    http.post('/changjing/jdetail', {
      id: to.params.id
    }).then(res => {
      next(vm => {
        if (res.status === 200) {
          vm.model = res.data.data[0]
          vm.file = vm.model.example
          vm.$iframe = document.createElement('iframe')
          const self = vm
          vm.$el.querySelector('.el-main').appendChild(vm.$iframe)
          vm.$iframe.style.display = 'none'
          vm.$iframe.src = vm.fileUrl
          vm.$iframe.onload = function () {
            const $style = document.createElement('style')
            $style.innerText = 'body > *{margin:auto;} img{max-width:100%;}'
            this.contentDocument.body.appendChild($style)
            self.loading = false
            this.style.display = 'block'
          }
          vm.fetchUser(vm.model.responsor, 'responsor')
          vm.fetchUser(vm.model.responsor2, 'responsor2')
        }
      })
    })
  },
  computed: {
    fileUrl() {
      return JSON.stringify(this.file) !== '{}' ? `/api/changjing/get?i=${this.file.exampleid || this.file.fileid}` : ''
    }
  },
  methods: {
    fetchUser(name, key) {
      http.post('/yuangong/simple', {
        name
      }).then(res => {
        res.data.yuangong_data.length > 0 && (this[key] = res.data.yuangong_data[0])
      })
    },
    showImage(e) {
      this.imgUrl = e.target.src
      this.visible = true
    },
    showUser(model, title) {
      if (model.name) {
        this.user.title = title
        this.user.model = model
        this.user.visible = true
      } else {
        this.$message.error(`没有${title}的信息`)
      }
    },
    change(file) {
      this.file = file
      this.$iframe.src = this.fileUrl
      this.$el.querySelector('.empty-tip').style.display = 'none'
    },
    download(file) {
      this.file = file
      const $a = document.createElement('a')
      $a.href = this.fileUrl.replace('/get?', '/download?')
      $a.download = file.examplename || file.name
      $a.click()
    }
  }
}
</script>

<style lang="scss">
.channel-detail {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  .empty-tip {
    z-index: 1;
    position: absolute;
    font-size: 20px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    p ~ p {
      margin-top: 10px;
    }
  }
  .el-tag {
    margin-right: 10px;
  }
  .el-header {
    background: #fff;
    border-bottom: 1px solid $color-border;
    line-height: 60px;
    color: #000;
    font-size: 16px;
    font-weight: bold;
  }
  .user {
    color: $color-theme !important;
    cursor: pointer;
    text-decoration: underline;
  }
  .el-aside {
    background: #fff;
    border-left: 1px solid #e4e7ed;
    .right-tabs {
      height: 100vh;
    }
    .el-form {
      padding: 24px;
      &-item {
        margin-bottom: 10px !important;
        display: flex;
      }
      &-item__label {
        color: #666;
        font-weight: bold;
        width: 115px;
      }
      &-item__content {
        flex: 1;
        width: 0;
        > div {
          display: flex;
          p {
            @include ellipsis();
            color: $color-theme;
            text-decoration: underline;
            cursor: pointer;
            margin-right: 10px;
          }
          i {
            width: 60px;
            cursor: pointer;
            color: #999;
          }
        }
      }
      span {
        color: #333;
      }
      img {
        width: 80px;
        height: 80px;
        cursor: pointer;
        margin: 0 4px;
      }
    }
  }
  .el-main {
    padding: 0;
    height: 100%;
    position: relative;
  }
  iframe {
    width: 100%;
    height: 100%;
  }
  .el-dialog img {
    width: 100%;
  }
}
.changjing-user-detail {
  .el-dialog__body > div {
    display: flex;
    padding: 30px;
  }
  article {
    font-size: 16px;
    padding-left: 30px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    b {
      color: #666;
      font-weight: bold;
    }
    p {
      line-height: 20px;
    }
    p ~ p {
      margin-top: 10px;
    }
  }
  img {
    width: 200px !important;
    height: 200px;
  }
}
</style>
